<template>
	<li class="accordion__item">
		<div
			class="accordion__trigger"
			:class="{'accordion__trigger_active': visible}"
			@click="open"
		>

			<!-- This slot will handle the title/header of the accordion and is the part you click on -->
			<slot name="accordion-trigger"></slot>

			<div class='svg-container'>
				<svg
					width="24px"
					height="24px"
					viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg"
					v-if="!visible"
				>
					<rect
						x="0"
						fill="none"
						width="24"
						height="24"
					/>
					<g>
						<path d="M21 13h-8v8h-2v-8H3v-2h8V3h2v8h8v2z" />
					</g>
				</svg>
				<svg
					width="24px"
					height="24px"
					viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg"
					v-else
				>
					<rect
						x="0"
						fill="none"
						width="24"
						height="24"
					/>
					<g>
						<path d="M3 11h18v2H3z" />
					</g>
				</svg>
			</div>

		</div>

		<transition
			name="accordion"
			@enter="start"
			@after-enter="end"
			@before-leave="start"
			@after-leave="end"
		>

			<div
				class="accordion__content"
				:class="{'open': visible}"
				v-show="visible"
			>
				<!-- This slot will handle all the content that is passed to the accordion -->
				<slot name="accordion-content"></slot>
			</div>
		</transition>
	</li>
</template>


<script>
export default {
	props: {},
	inject: ['Accordion'],
	data() {
		return {
			index: null,
		};
	},
	computed: {
		visible() {
			return this.index == this.Accordion.active;
		},
	},
	methods: {
		open() {
			if (this.visible) {
				this.Accordion.active = null;
			} else {
				this.Accordion.active = this.index;
			}
		},
		start(el) {
			el.style.height = el.scrollHeight + 'px';
		},
		end(el) {
			el.style.height = '';
		},
	},
	created() {
		this.index = this.Accordion.count++;
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.accordion {
	&__item {
		cursor: pointer;
		position: relative;
		background: var(--light-grey);
		border-radius: 0;
	}

	&__trigger {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px 50px;
		gap: 20px;
		transition: 0.2s ease all;
		color: var(--navy);
		text-indent: 0;

		@media (max-width: $mobile-xl) {
			padding: 20px 20px;
		}

		h3 {
			margin: 0;
			font: normal normal normal 30px/40px var(--primary-font-family);
			text-transform: capitalize;
		}

		// &:hover {
		// 	background: var(--stone);
		// 	transition: 0.2s ease all;
		// }
		/* 
		&_active {
			background: var(--stone);
		} */

		p {
			// text-transform: uppercase;
			max-width: calc(100% - 40px);
			margin: 0;
			color: var(--navy);
			text-transform: unset;

			@media (max-width: $mobile-xl) {
				max-width: calc(100% - 20px);
			}
		}

		.svg-container {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 30px;
			height: 30px;
			border-radius: 50%;
			border: 1px solid var(--orange);
		}

		svg {
			path {
				fill: var(--orange);
			}
		}
	}

	&__content {
		padding: 0 35px 0;
		color: var(--navy);

		@media (max-width: $mobile-xl) {
			padding: 0 20px;
		}

		&::v-deep {
			> p,
			div p {
				margin: 0;
				padding: 0 16px 16px;
				color: var(--navy);
				font: normal normal 300 25px/30px var(--primary-font-family) !important;
				text-indent: 0;

				@media (max-width: $mobile-xl) {
					padding: 0 0 16px;
				}

				&:last-of-type {
					margin-bottom: 0;
					font: normal normal 300 25px/30px var(--primary-font-family) !important;
					padding-bottom: 30px;
				}

				strong {
					font: normal normal bold 25px/30px var(--primary-font-family) !important;
				}
			}

			> p a {
				color: var(--navy);
				font: normal normal 300 25px/30px var(--primary-font-family) !important;
				text-indent: 0;

				strong {
					font: normal normal bold 25px/30px var(--primary-font-family) !important;
				}
			}

			p {
				color: var(--navy);
				font: normal normal 300 25px/30px var(--primary-font-family) !important;
				text-indent: 0;

				strong {
					font: normal normal bold 25px/30px var(--primary-font-family) !important;
				}
			}

			ul {
				display: flex;
				flex-direction: column;
				margin: 0 0 20px 20px;
				padding: 0 20px 0 18px;
				gap: 10px;

				li {
					color: var(--navy);
					font: normal normal 300 25px/30px var(--primary-font-family) !important;
					list-style-type: disc;

					strong {
						font: normal normal bold 25px/30px var(--primary-font-family) !important;
					}

					a {
						color: var(--navy);
						font: normal normal 300 25px/30px var(--primary-font-family) !important;
						text-indent: 0;
						padding: 0;

						strong {
							font: normal normal bold 25px/30px var(--primary-font-family) !important;
						}
					}
				}
			}

			ol {
				display: flex;
				flex-direction: column;
				margin: 0 0 20px 20px;
				padding: 0 20px 0 18px;
				gap: 10px;
				list-style: auto;

				li {
					color: var(--navy);
					font: normal normal 300 15px/20px var(--primary-font-family) !important;
					list-style-type: disc;

					strong {
						font: normal normal bold 15px/20px var(--primary-font-family) !important;
					}

					a {
						color: var(--navy);
						font: normal normal 300 15px/20px var(--primary-font-family) !important;
						text-indent: 0;
						padding: 0;

						strong {
							font: normal normal bold 15px/20px var(--primary-font-family) !important;
						}
					}
				}
			}

			.site_button {
				margin-top: 16px;
				margin-left: 16px;
			}

			hr {
				margin: 0 16px 16px;
				width: calc(100% - 32px);
			}
		}

		&.open {
			&::v-deep {
				.site_button_secondary {
					margin-bottom: 16px;
					margin-left: 16px;
				}
			}
		}
	}
}

.accordion-enter-active,
.accordion-leave-active {
	will-change: height, opacity, padding-bottom;
	transition: height 0.3s ease, opacity 0.3s ease, padding-bottom 0.3s ease;
	overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
	height: 0 !important;
	opacity: 0;
	padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/AccordionItem.vue